"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configReducer = configReducer;
var _types = require("./types");
var _types2 = require("../blitz/types");
var _Orientation = require("../../common/enums/Orientation");
var _Channel = require("../../common/enums/Channel");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  screenSize: {
    height: window.innerHeight,
    width: window.innerWidth,
    orientation: _Orientation.Orientation.Portrait,
    ratio: window.innerWidth / window.innerHeight
  },
  fastPlayAllowed: true,
  vibrateAllowed: true,
  blitzAllowed: true,
  blitzMaxRounds: 250,
  blitzMinRounds: 10,
  spaceToSpinAllowed: true,
  autoPlayAllowed: true,
  autoPlayTimeBetweenRounds: 500,
  autoPlayRoundsToPlay: 50,
  spaceToSpin: true,
  minLoaderTime: 0,
  sound: true,
  music: true,
  allowLandscape: true,
  allowPortrait: true,
  channel: _Channel.Channel.Mobile,
  autoAdjustBet: true,
  autoAdjustBetAllowed: true,
  hideCurrencySignAllowed: true,
  msgP: false,
  idleTime: 5000,
  blurred: false,
  splashScreen: true,
  blitzSplashScreenHide: false,
  hsAllowed: true,
  //  displayShockLogo: false,
  //  displayClock:false
  keepAliveInterval: 30000,
  fullscreen: true,
  manualFreeSpins: false,
  coinsFeatureAsPayline: false,
  ftb: true,
  spinDurationMin: 20 // this is important, removing this might break alot of games where freespins are automatic.
};
function configReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.SERVER_CONFIG:
      return Object.assign({}, state, action.payload);
    case _types.WINDOW_RESIZE:
      return Object.assign({}, state, {
        screenSize: _objectSpread(_objectSpread({}, state.screenSize), action.payload)
      });
    case _types.SET_RESOLUTION:
      // this is a bit of a hack, we often need channel in resize so we pass it alone with the ScreenSize object.
      return Object.assign({}, state, {
        screenSize: _objectSpread(_objectSpread({}, state.screenSize), {}, {
          resolution: action.payload,
          channel: state.channel
        })
      });
    case _types.AUTO_ADJUST_BET_TOGGLE:
      return Object.assign({}, state, {
        autoAdjustBet: !state.autoAdjustBet
      });
    case _types.FAST_PLAY_TOGGLE:
      return Object.assign({}, state, {
        fastPlay: !state.fastPlay
      });
    case _types.SOUND_TOGGLE:
      return Object.assign({}, state, {
        sound: !state.sound
      });
    case _types.MUSIC_TOGGLE:
      return Object.assign({}, state, {
        music: !state.music
      });
    case _types2.BLITZ_FEATURE_STOP_TOGGLE:
      return Object.assign({}, state, {
        blitzStopOnFeature: !state.blitzStopOnFeature
      });
    case _types.VIBRATE_TOGGLE:
      return Object.assign({}, state, {
        vibrate: !state.vibrate
      });
    case _types.SPIN_ON_SPACE_TOGGLE:
      return Object.assign({}, state, {
        spaceToSpin: !state.spaceToSpin
      });
    case _types.HIDE_CURRENCY_SIGN_TOGGLE:
      return Object.assign({}, state, {
        hideCurrencySign: !state.hideCurrencySign
      });
    case _types.WINDOW_BLUR:
      return Object.assign({}, state, {
        blurred: true
      });
    case _types.WINDOW_FOCUS:
      return Object.assign({}, state, {
        blurred: false
      });
    case _types.HIDE_SPLASH_SCREEN:
      return Object.assign({}, state, {
        splashScreen: false
      });
    case _types2.SPLASH_SCREEN_HIDE_TOGGLE:
      return Object.assign({}, state, {
        splashScreenHide: !state.splashScreenHide
      });
    case _types.CURRENCY_SIGN_HIDE_TOGGLE:
      return Object.assign({}, state, {
        hideCurrencySign: !state.hideCurrencySign
      });
    case _types2.BLITZ_SPLASH_SCREEN_HIDE_TOGGLE:
      return Object.assign({}, state, {
        blitzSplashScreenHide: !state.blitzSplashScreenHide
      });
    case _types.SET_AUTO_PLAY_ROUNDS:
      return Object.assign({}, state, {
        autoPlayRoundsToPlay: action.payload
      });
  }
  return state;
}
//# sourceMappingURL=reducer.js.map